import ModalOfficeMapPresenter from "../components/modal-office-map/presenter/modal-office-map.js";

const triggers = document.querySelectorAll(`.header-address-button, .footer-address-button, .header-cart-list__button`);

Array.from(triggers)
  .forEach((trigger) => {
    const modalOfficeMapComponent = new ModalOfficeMapPresenter(trigger);
    modalOfficeMapComponent.init();
  });
